// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs--1d09r","tip-icon":"tip-icon--1dwmt","tipIcon":"tip-icon--1dwmt","tip-overlay":"tip-overlay--3wiqI","tipOverlay":"tip-overlay--3wiqI"};